export const PARTNER_DEALS_STORAGE_KEY = 'partner-deals-storage';
